
// Common Error Messages
const commonPartySelectionIsRequired = "Please Select Party"

const divisionSelectionIsRequired = "Please Select division"



const atLeastOneCheckboxCheck = "Please select at least one checkbox before downloading."

// Image Related Error Message 
const imageNotUploaded = "Images not uploaded"

const StockNotAvaliable = "Stock not Available"



// common functions alert Message
const actionNotDefined = "Action Not defined"
const duplicateTransactionDetected = "Duplicate transaction detected. Please wait while the current request is processing."
const noFieldsSelectedForDownload = "No fields selected for download"
const selectPartyName = "Please Select Party"



const selectCustomerName = "Please Select Customer"

const IsRequired = 'Is Required.'
const changeCustomerName = "Are you sure you want to change the customer ?"
const deleteOrNot = "Are you sure you want to delete this "

const selectSameCustomer = "Multiple customers are not allowed"




// Loading Sheet Master
const routeNameIsRequired = "RouteName Is Required"

//Item Dropdown Add button Error Message
const itemNameIsRequired = "Please Select Item Name"
const ItemNameAlreadyExists = "This Item Name Already Exists"
const itemQtyIsRequired = "Please Enter One Item Quantity"

//Payment and Receipt Pages Error Message
const bankNameIsRequired = 'Bank Name Is Required'
const depositorBankIsRequired = "Depositor Bank Name Is Required"
const documentNoIsRequired = "DocumentNo Is Required"
const chequeIsRequired = "Cheque Number Is Required"
const receiptModeIsRequired = "Receipt Mode Is Required"
const invoiceNoIsRequired = "Invoice Number is Required"
const atLeastOneInvoiceRequired = "Please Select at Least One Invoice."
const amountPaidValueIsExcess = "Amount Paid value is Excess "
const amountPaidValueIsShort = "Amount Paid value is Short "
const paymentAmountGreaterThanZero = "The payment amount must be greater than zero."
const receiptAmountGreaterThanZero = "The Receipt amount must be greater than zero."

// Import Excel Field Map , Party Map and Invoice Excel Upload pages Error Message
const chooseAnyFile = "Please choose xlsx file..."
const waitForDownloadFieldDetails = "Please wait Downloading field Details."
const unSupportedFileFormat = "Unsupported file format. Please select an Excel (XLSX)."
const doYouConfirmChoice = "Do you confirm your choice?"
const mappingNotMatchError = "Mapping not match."
const PricelistIsRequired = "Please Select PriceList"
const paymentORcodeIsRequired = "Payment QR not uploaded"
const selectMappingType = "Please select Mapping Type"

const selectValidExcelFile = "Please select a valid excel file."

// Mobile Retailer Send Save Button Error Message
const atLeastOneRetailerIsRequired = "At least One Retailer is Selected"

// Management Parties (Party Assign) Save Button Error Message
const atLeastOnePartySelectionRequired = "At least One Party is Selected"

// MRP , Rate,GST and Margin Page Error Messages
const deleteThisItem = "Are you sure you want to delete this Item Rate?"
const effectiveDateIsRequired = "Please select EffectiveDate"
const effectiveDateAndPriceListIsRequired = "Please select EffectiveDate and PriceListName"
const effectiveDateAndDivisionIsRequired = "Please select EffectiveDate."
const MRPIsRequired = "Please Enter MRP"
const marginISRequired = "Please Enter Margin"
const enterGSTPercentage_HSNCodeIsRequired = "Please Enter One GSTPercentage & HSNCode"
const RateIsRequired = "Please Enter Rate"

//Item Master Bulk Update 
const fieldSelectionIsRequired = "Field selection is Required."

//Item Master 
const groupTypeIsRequired = "Group Type is Required."
const updateOneFieldIsRequired = "Update At least One Field"
const subGroupNameIsRequired = 'SubGroup Name is Required'
const GroupIDError = "Error for Group ID"
const categoryAlreadyExists = "Category alredy Select"
const imageUploadSuccessfully = "Item Image Remove successfully"
const selectImageFile = "Please Select Image file"

// claim Tracking Entry 
const CreditNote_Not_Upload = "Credit Note Not Uploaded"
const deleteClaim = "Do you want To Delete Claim ?"

// Invoice Master
const rateNotAvailable = " Rate not available."
const multiple_MRP_notAllowed = " Multiple MRP’S Invoice not allowed."
const multiple_Rate_notAllowed = " Multiple Rate’S Invoice not allowed."

const customerIsRequired = "Customer is required."

// Sales Return 
const batchCode_notAvailable = "Item Name and batch code not available"
const selectInvoiceNo = "Select Invoice No."
const approvedQtyIsRequired = "Please Enter Approve Quantity"
const imageRemoveSuccessfully = "Return Iamge Remove Successfully"
const returnImageNotUploaded = "Return Image Not Uploaded"
const selectOneCheckbox = "Please Select One Checkbox"

// page Master Error Message 
const selectPageAcces = "At Least One PageAccess is Select"
const selectRelatedID = "Please Select Related Page ID"
const pageField_IsRequired = "PageFields is Required"

// Profile Menu
const setNewPassword = "Set NewPassoword"
const newPasswordNotMatch = "Confirm does not match to NewPassword "
const changePassword = "Do you Want to Change Password ?"

// Item Master 
const gstDetailsIsRequired = "GST Details Required"
const mrpDetailsIsRequired = "MRP Details Required"
const groupType_IsRerquired = "Please Select GroupType value...!"
const group_IsRerquired = "Please select group value...!"
const enterValue = "Please enter value"
const No_Kg_IsRerquired = "No. and Kg unit conversions are compulsory"

// Party Master 
const addressDefaultTrueSelect = "At least one Address Details IsDefault true"
const addressIsRequired = "Address details is required"
const selectField = "Please select field"
const updateAtLeastOneField = "Update At least One Field"
const DistrictIsRequired = 'District Name is Required'
const invalidMobile = 'InValid Mobile No'
const invalidEmail = 'InValid Email'
const invalidPAN = 'InValid Pan No '
const invalid_GSTIN_no = 'InValid GSTIN No'
const invalid_Name = 'InValid Name'
const OpeningBalanceDateRequired = 'OpeningBalance Date is Required'
const fillAddressDetailsInTable = "Don't forget to fill in the address details in the table."
const defaultAddressIsSelected = "Atleast One Default Address is Select "

// Role Access
const selectParty = "Select Party"
const partyAlreadyExist = "Party Already Exist"
const pageAlreadyExist = "Page Already Exist"
const selectPage = "Please Select Page"
const selectRole = "Please Select Role"
const atLeastOneRoleAddInTable = "At Least One Role  Add in the Table"

//GRN 
const assignItem = "Please Assign-Item."
const hideInvoiceOrNot = "Do you want To Hide Invoice ?"
const unHideInvoiceOrNot = "Do you want To Unhide Invoice ?"

// Stock Entry
const batchCodeAlreadyExist = "This BatchCode Already Exist"
const changeOneStockQty = "Please Enter One Changed Stock Quantity"
const selectItemName = "Select Item Name"
const stockIsZero = "If new stock is added then the previous whole item stock will become zero."
const unitIsRequired = 'Unit Is Required'
const mrpIsRequired = 'MRP Is Required'
const gstIsRequired = 'GST Is Required'
const batchCodeIsRequired = 'BatchCode Is Required'
const rateIsRequired = "Rate Is Required."

//Inter Branch Module (BOM)
const atLeastOneMaterialDataAddInTable = "At Least One Matrial data Add in the table"
const itemQtyIsReq = 'Item Quantity Is Required'
const contentItemQtyIsReq = 'Content Item Is Required'

// Order Error Message
const select_PO_Type = "Please Select PO Type"
const itemRateIsRequired = "This Item Rate Is Required."
const enterOneTerms_and_Cond = "Please Enter One Terms And Condition"
const selectOneOrder = "Please Select One Order"
const selectSupplier = "Please Select Supplier"

//Report Error Message
const selectUnit = "Please Select Unit"
const recordNotAvailable = "Records Not available "

const ImageIsRequired = 'Only JPG, JPEG, or PNG files are allowed.'
const AllItemExist = 'All Item Exist'

const AdvanceAmount = 'Advance Amount is Greater than Order Amount'
const apiBlockedInTestEnv = 'This API is blocked in the test environment.'

// SweetPOS Rate Master
const rateTypeIsRequired = "Rate Type is required"

export const alertMessages = {
    duplicateTransactionDetected,
    rateTypeIsRequired,
    defaultAddressIsSelected,
    fillAddressDetailsInTable,
    deleteOrNot,
    recordNotAvailable,
    selectUnit,
    deleteClaim,
    selectSupplier,
    selectOneOrder,
    unHideInvoiceOrNot,
    itemRateIsRequired,
    enterOneTerms_and_Cond,
    select_PO_Type,
    contentItemQtyIsReq,
    itemQtyIsReq,
    atLeastOneMaterialDataAddInTable,
    batchCodeIsRequired,
    gstIsRequired,
    mrpIsRequired,
    rateIsRequired,
    unitIsRequired,
    stockIsZero,
    selectItemName,
    changeOneStockQty,
    batchCodeAlreadyExist,
    hideInvoiceOrNot,
    assignItem,
    atLeastOneRoleAddInTable,
    selectRole,
    selectPage,
    pageAlreadyExist,
    partyAlreadyExist,
    selectParty,
    invalid_Name,
    OpeningBalanceDateRequired,
    invalid_GSTIN_no,
    invalidPAN,
    invalidEmail,
    invalidMobile,
    commonPartySelectionIsRequired,
    routeNameIsRequired,
    atLeastOneInvoiceRequired,
    itemQtyIsRequired,
    itemNameIsRequired,
    ItemNameAlreadyExists,
    changeCustomerName,
    IsRequired,
    bankNameIsRequired,
    documentNoIsRequired,
    invoiceNoIsRequired,
    paymentAmountGreaterThanZero,
    depositorBankIsRequired,
    chequeIsRequired,
    receiptAmountGreaterThanZero,
    receiptModeIsRequired,
    amountPaidValueIsExcess,
    amountPaidValueIsShort,
    chooseAnyFile,
    waitForDownloadFieldDetails,
    unSupportedFileFormat,
    doYouConfirmChoice,
    mappingNotMatchError,
    PricelistIsRequired,
    atLeastOneRetailerIsRequired,
    effectiveDateIsRequired,
    effectiveDateAndDivisionIsRequired,
    effectiveDateAndPriceListIsRequired,
    deleteThisItem,
    MRPIsRequired,
    atLeastOnePartySelectionRequired,
    marginISRequired,
    enterGSTPercentage_HSNCodeIsRequired,
    fieldSelectionIsRequired,
    groupTypeIsRequired,
    updateOneFieldIsRequired,
    subGroupNameIsRequired,
    GroupIDError,
    paymentORcodeIsRequired,
    categoryAlreadyExists,
    CreditNote_Not_Upload,
    rateNotAvailable,
    multiple_MRP_notAllowed,
    customerIsRequired,
    batchCode_notAvailable,
    selectMappingType,
    imageUploadSuccessfully,
    selectImageFile,
    selectInvoiceNo,
    imageNotUploaded,
    approvedQtyIsRequired,
    imageRemoveSuccessfully,
    returnImageNotUploaded,
    selectOneCheckbox,
    selectPageAcces,
    selectRelatedID,
    pageField_IsRequired,
    actionNotDefined,
    noFieldsSelectedForDownload,
    setNewPassword,
    newPasswordNotMatch,
    changePassword,
    selectPartyName,
    selectValidExcelFile,
    gstDetailsIsRequired,
    mrpDetailsIsRequired,
    groupType_IsRerquired,
    group_IsRerquired,
    enterValue,
    addressDefaultTrueSelect,
    addressIsRequired,
    selectField,
    updateAtLeastOneField,
    DistrictIsRequired,
    ImageIsRequired,
    No_Kg_IsRerquired,
    atLeastOneCheckboxCheck,
    RateIsRequired,
    AllItemExist,
    AdvanceAmount,
    selectSameCustomer,
    StockNotAvaliable,
    divisionSelectionIsRequired,
    selectCustomerName,
    multiple_Rate_notAllowed,
    apiBlockedInTestEnv
};


